import React, { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminReset() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (pw.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    if (pw !== pw2) { toast.error("Passwords don't match"); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: pw });
      setDone(true);
      toast.success("Password updated");
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Reset failed — request a new link");
    } finally { setBusy(false); }
  };

  return (
    <main className="pt-40 pb-24 min-h-screen" data-testid="admin-reset-page">
      <div className="max-w-sm mx-auto px-6 text-center">
        <Lock className="mx-auto mb-6" size={30} color="#D4AF37" strokeWidth={1.3} />
        <h1 className="font-serif text-4xl font-light mb-4">Set New Password</h1>
        {done ? (
          <div data-testid="reset-success">
            <p className="text-[#A1A1AA] text-sm mb-8">Your admin password has been updated.</p>
            <Link to="/admin" data-testid="reset-goto-login"
              className="inline-block bg-[#D4AF37] text-black px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] hover:bg-[#C5A028] transition-colors">
              Go to Admin Login
            </Link>
          </div>
        ) : !token ? (
          <p className="text-[#A1A1AA] text-sm" data-testid="reset-no-token">This link is missing its token. Use the link from your reset email, or request a new one from the admin login screen.</p>
        ) : (
          <>
            <p className="text-[#71717A] text-xs font-mono mb-8">Choose a new admin password (min 8 characters).</p>
            <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password" data-testid="reset-password-input"
              className="w-full bg-transparent border-b border-zinc-600 focus:border-[#D4AF37] outline-none py-3 text-center font-mono text-sm placeholder:text-[#52525B] mb-6 transition-colors" />
            <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} placeholder="Confirm new password" data-testid="reset-password-confirm"
              className="w-full bg-transparent border-b border-zinc-600 focus:border-[#D4AF37] outline-none py-3 text-center font-mono text-sm placeholder:text-[#52525B] transition-colors" />
            <button onClick={submit} disabled={busy} data-testid="reset-submit-btn"
              className="mt-8 w-full bg-[#D4AF37] text-black py-4 font-mono text-xs uppercase tracking-[0.2em] hover:bg-[#C5A028] transition-colors disabled:opacity-50">
              {busy ? "Saving…" : "Save New Password"}
            </button>
          </>
        )}
      </div>
    </main>
  );
}
